var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".noData-pic{background:url(" + escape(require("../../static/img/yemian-bg.png")) + ") no-repeat top;background-size:2.96rem 2.96rem;margin:2rem auto 0;width:100%}.noData-text{font-size:.48rem;text-align:center;height:2rem;line-height:2rem;padding-top:3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01c4b266","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NoRecord.vue
// module id = 398
// module chunks = 0